import { useState } from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";

export const AIPlanIdentityHeader = () => (
  <div data-testid="ai-plan-identity-header">
    <p className="text-[10px] uppercase tracking-[0.2em] font-bold gradient-text-rose-purple" data-testid="ai-plan-label">✨ AI Personalized Plan</p>
    <h2 className="font-display text-xl sm:text-2xl text-charcoal leading-tight mt-1" data-testid="ai-plan-heading">
      Here&apos;s a Celebration Plan Made Just for Your Loved One ❤️
    </h2>
    <p className="text-xs sm:text-sm text-charcoal/60 mt-1 leading-snug" data-testid="ai-plan-subline">
      We&apos;ve considered their preferences, relationship and budget to create something special.
    </p>
  </div>
);

const copyText = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand("copy");
    ta.remove();
    return ok;
  }
};

export const CopyMessageButton = ({ text }) => {
  const [copied, setCopied] = useState(false);
  const onCopy = async () => {
    if (await copyText(text)) {
      setCopied(true);
      toast.success("Copied!");
      setTimeout(() => setCopied(false), 1800);
    } else {
      toast.error("Couldn't copy — please select the text instead");
    }
  };
  return (
    <button type="button" onClick={onCopy} aria-label="Copy message" data-testid="copy-personal-message"
      className={`flex-shrink-0 inline-flex items-center gap-1 rounded-full border px-2 py-1 text-[11px] font-semibold transition-colors ${copied ? "border-emerald-300 bg-emerald-50 text-emerald-700" : "border-rose-200 bg-white/70 text-rose-600 hover:bg-rose-50"}`}>
      {copied ? <Check className="w-3 h-3" strokeWidth={3} /> : <Copy className="w-3 h-3" />}
      {copied ? "Copied!" : "Copy"}
    </button>
  );
};
